import MarkdownIt from 'markdown-it';
import mk from 'markdown-it-katex';

const MarkdownParser = new MarkdownIt({
    linkify: true,
    typographer: true,
}).use(mk);

MarkdownParser.set({breaks: false});

export default MarkdownParser;